package br.com.vvrefeicoes.portal.core.util

import kotlinx.browser.window

actual fun guideShareLink(id: String): String = window.location.href.substringBefore('#') + "#/guias-e-manuais/$id"
